module.exports = __webpack_public_path__ + "media/images/clock-circle-f17e036f3b5be9cbce559ff9d0386b38.svg";